"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _heroBanner = _interopRequireDefault(require("../components/hero-banner/hero-banner"));

var _sections = require("../components/contentful-views/sections");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * HeroBanner for all the heroes out there (especially you).
 * https://app.contentful.com/spaces/ljtyf78xujn2/content_types/heroBanner/fields
 * @param {Object} props
 * @param {Object} props.model
 */
var HeroBannerWidget = function HeroBannerWidget(_ref) {
  var model = _ref.model;
  var ctaButton = (0, _sections.getWidget)(_lodash["default"].get(model, 'fields.ctaButton'));

  var backgroundImage = _lodash["default"].get(model, 'fields.backgroundImage.fields.file.url');

  var backgroundImageMobile = _lodash["default"].get(model, 'fields.backgroundImageMobile.fields.file.url');

  var videos = _lodash["default"].get(model, 'fields.video');

  return /*#__PURE__*/_react["default"].createElement(_heroBanner["default"], _extends({}, model.fields, {
    backgroundImage: backgroundImage,
    backgroundImageMobile: backgroundImageMobile,
    ctaButton: ctaButton,
    videos: videos
  }));
};

HeroBannerWidget.propTypes = {
  model: _propTypes["default"].shape({})
};
HeroBannerWidget.defaultProps = {
  model: {}
};
(0, _sections.registerWidget)('heroBanner', HeroBannerWidget);
var _default = HeroBannerWidget;
exports["default"] = _default;